import { ContentSuggestionValue } from './ContentSuggestionValue';

const SEARCHABLE_TEXT_MIN_LENGTH = 3;
const MAX_RESULTS = 200;
const NONE: [] = [];

const matchesSpecialPattern = (
  searchableText: string,
  searchString: string,
  regExp: RegExp,
) => {
  const specialPatternMatch = regExp.exec(searchString);
  if (specialPatternMatch) {
    const specialPattern = specialPatternMatch[0].toLowerCase();
    const matches = searchableText.match(regExp) ?? [];
    return matches.some((match) => match === specialPattern);
  }
  return true;
};

// Function to check "RL zu" or "FW zu" pattern
const matchesRLorFWPattern = (
  searchableText: string,
  searchString: string,
): boolean =>
  matchesSpecialPattern(searchableText, searchString, /(RL zu|FW zu)/gi);

// Function to check "<category abbreviation> <roman number>" pattern
const matchesBookAbbreviationRomanPattern = (
  searchableText: string,
  searchString: string,
): boolean =>
  matchesSpecialPattern(
    searchableText,
    searchString,
    /(SGB|AGSGB|RBEG|AsylbLG) ?[IVX]+/gi,
  );

// Function to check "§ <number><letter>" pattern
const matchesParagraphPattern = (
  searchableText: string,
  searchString: string,
): boolean =>
  matchesSpecialPattern(
    searchableText,
    searchString,
    /§{1,2}\s*\d{1,4}[a-zA-Z]{0,2}/g,
  );

const filterContentSuggestions = (
  contentOptions: ContentSuggestionValue[],
  searchString: string,
) => {
  if (searchString.length < SEARCHABLE_TEXT_MIN_LENGTH) {
    return NONE;
  }

  return contentOptions
    .filter((suggestion) => {
      const searchableText =
        `${suggestion.treeElementParent.abbreviation} ${suggestion.treeElement.name}`.toLowerCase();
      const searchableWords = new Set(searchableText.split(' '));

      const trimmedSearchString = searchString.trim();

      if (!matchesRLorFWPattern(searchableText, trimmedSearchString)) {
        return false;
      }

      if (
        !matchesBookAbbreviationRomanPattern(
          searchableText,
          trimmedSearchString,
        )
      ) {
        return false;
      }

      if (!matchesParagraphPattern(searchableText, trimmedSearchString)) {
        return false;
      }

      return trimmedSearchString
        .split(' ')
        .every((word) =>
          Array.from(searchableWords).some((s) =>
            s.startsWith(word.toLowerCase()),
          ),
        );
    })
    .slice(0, MAX_RESULTS);
};

export default filterContentSuggestions;
